import React from 'react';
import IntroductionSection from '../IntroductionSection';
import ComingSoonSection from '../ComingSoonSection';
import HotFeatureSection from '../HotFeatureSection';
import FeatureSection from '../FeatureSection';
import IndustryLeaderSection from '../IndustryLeaderSection';
import TestimonialSection from '../TestimonialSection';
import { BACKGROUND_BLACK } from '../../../../styles/Colors';

const styles = {
  screenContainer: {
    backgroundColor: BACKGROUND_BLACK,
  },
};

const Home = () => (
  <div style={styles.screenContainer}>
    <IntroductionSection />
    <ComingSoonSection />
    <HotFeatureSection />
    <FeatureSection />
    <IndustryLeaderSection />
    <TestimonialSection />
  </div>
);

export default Home;
